/**
 *
 * @description Checks if specified keys have missing translations in the provided object.
 * @description This can be used to check translations in a wizard for example
 */
export const checkTranslations = <T extends object>(formValues: T, keys: (keyof T)[]): boolean => {
    const locales = ['_nl_be', '_en_us', '_fr_fr', '_de_de'];
    return keys.some((key) => {
        const missingTranslation = locales.some((locale) => {
            const value = formValues?.[`${String(key)}${locale}` as keyof T];
            return value === '' || value === null;
        });
        const baseValue = formValues?.[key];
        return missingTranslation && baseValue !== '' && baseValue !== null;
    });
};
